"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCAL_STORAGE_KEY = void 0;
exports.LOCAL_STORAGE_KEY = '$$charts::config';
